import * as React from "react";

import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import ShopIcon from "@mui/icons-material/Shop";
import ListIcon from "@mui/icons-material/List";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { Link, useLocation, useMatch } from "react-router-dom";

const mainListItems = [
  { text: "Kullanıcılar", icon: <PeopleRoundedIcon />, to: "/users" },
  {
    text: "Loglar",
    icon: <ListIcon />,
    to: "/systemlogs",
  },
  {
    text: "Siparişler",
    icon: <ShopIcon />,
    to: "/purchases",
  },
];

const secondaryListItems = [
  { text: "Settings", icon: <SettingsRoundedIcon /> },
  { text: "About", icon: <InfoRoundedIcon /> },
  { text: "Feedback", icon: <HelpRoundedIcon /> },
];

interface ListItemLinkProps {
  icon?: React.ReactElement<any>;
  text: string;
  to: string;
}
function ListItemLink(props: ListItemLinkProps) {
  const { icon, text, to } = props;
  const selected = useMatch(to);
  const location = useLocation();
  return (
    <ListItemButton
      component={Link}
      to={{ pathname: to }}
      state={{ text, from: location }}
      selected={!!selected}
    >
      {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
      <ListItemText primary={text} />
    </ListItemButton>
  );
}
export default function MenuContent() {
  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: "space-between" }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: "block" }}>
            <ListItemLink {...item} />
          </ListItem>
        ))}
      </List>

      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: "block" }}>
            <ListItemButton>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
